import { render } from "./InstallmentOptions.vue?vue&type=template&id=2982b85d"
import script from "./InstallmentOptions.vue?vue&type=script&lang=ts"
export * from "./InstallmentOptions.vue?vue&type=script&lang=ts"
script.render = render

export default script